import React from "react";
import { ChevronDown } from "lucide-react";

export function Faq({ items, title, testPrefix }) {
  return (
    <section className="max-w-4xl mx-auto px-6 lg:px-10 py-20">
      <h2 className="brand-heading text-3xl sm:text-4xl text-[color:var(--bk-navy)]">{title}</h2>
      <div className="mt-8 divide-y divide-[color:var(--bk-line)] border-y border-[color:var(--bk-line)]">
        {items.map(([q, a], i) => (
          <details key={i} data-testid={`${testPrefix}-faq-${i}`} className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 brand-heading text-lg text-[color:var(--bk-navy)]">
              {q}<ChevronDown className="w-5 h-5 shrink-0 transition-transform group-open:rotate-180" />
            </summary>
            <p className="mt-3 text-[15px] text-[color:var(--bk-navy)]/75 leading-relaxed">{a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
